import { NodeViewContent, NodeViewWrapper } from '@tiptap/react'

// @ts-ignore
export const Component = props => {
	const editable = props.editor.isEditable
	const align = props.node.attrs.align

	if (editable) {
		return (
			<NodeViewWrapper className="wtls-topblock wtls-topblock-tt w-full">
				<NodeViewContent
					className="flex w-full max-w-full [&>*]:inline-block [&>*]:max-w-full"
					style={{ justifyContent: align }}
				/>
			</NodeViewWrapper>
		)
	} else {
		return (
			<NodeViewWrapper className="wtls-topblock-tt mb-4 w-full">
				<NodeViewContent
					className="flex w-full max-w-full [&>*]:inline-block [&>*]:max-w-full"
					style={{ justifyContent: align }}
				/>
			</NodeViewWrapper>
		)
	}
}

export default Component
